import PropTypes from "prop-types";
import styles from "./FilterHeaderButton.module.scss";

const FilterHeaderButton = ({ name, onClick, disabled, ariaLabel }) => {
  return (
    <button
      className={`${styles.filterHeaderButton} ${
        name === "Clear all" || name === "Create new"
          ? styles["filterHeaderButton--clear"]
          : ""
      } ${disabled ? styles["filterHeaderButton--disabled"] : ""}`}
      aria-label={ariaLabel}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {name}
    </button>
  );
};
FilterHeaderButton.propTypes = {
  name: PropTypes.string,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default FilterHeaderButton;
